import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';
import 'plugs/jquery.simplyscroll.min.js';
import 'plugs/jquery.pause.min.js';
import 'plugs/jquery.twzipcode.js';

var $window = $(window);
var winW,winH,footerH,bodyH,scrollTop;
$(function() {    
    $('body').addClass('fade-in');
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    //scroll animation
    var win_height_padded = $window.height() * 0.9;
    window.setTimeout(function(){
        $window.on('scroll', revealOnScroll);
        revealOnScroll();
    },100);
    //mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body,html'),
    $header = $('header');

    menuicon.on('click',function(){
        var $this = $(this);
        if(!$header.hasClass('menu-expanded')){
            $header.addClass('menu-expanded');
            nav.stop().fadeIn();
            // $body.css({'overflow':'hidden'}).addClass('modal_open');
        }else{
            $header.removeClass('menu-expanded');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            // $body.css({'overflow':''}).removeClass('modal_open');
        }
        return false;
    });
    
    $('.navBox a').on('click',function(){
        var obj = $(this).attr('href');
        $("html,body").animate({ scrollTop: $(obj).offset().top}, 1000, 'easeOutExpo');
        $header.removeClass('menu-expanded');
        nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        return false;
    });
    //open real    
    var btn_close = $('span.close,a.close'),
        btn_open = $('a[data-popup]'),
        //$body_overlay = $('.popup_bg'),
        $real_overlay = $('.overbg'),
        window_top,
        poval,
        obj;
    btn_open.on('click',function(event){
        window_top = scrollTop;
        poval = $(this).data('popup');
        obj = $(this).attr('href');
        $(obj).addClass(poval);
        $body.addClass('modal-open');
        $real_overlay.fadeIn('800');
        $('#modal-content').fadeIn('800');
        if(poval == "privacy"){
            $('#modal-content').fadeIn('800').addClass("min-vh");
        }else{            
            $('#modal-content').fadeIn('800');
        }
        return false;
    });
    btn_close.on('click',function(){       
        $real_overlay.fadeOut(500);
        $('.modal-content').fadeOut(500,function(){
            $('.modal-content').removeClass("min-vh");
            $body.removeClass('modal-open');
            $(obj).removeClass(poval);
        });
        if(winW < 1024){
          $window.scrollTop(window_top);
        }else{
          $body.removeAttr('data-top');
        }        
    });
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('main').css('min-height',bodyH);
        if(winW > 991){
            $header.removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
    }).resize();
    $(window).on('scroll', function() {
        scrollTop = $(this).scrollTop();
        var top = $('#topBtn');
        if (scrollTop >= 47) {
            top.addClass('open');
        }else{
            top.removeClass('open');
        }
    }).scroll();
    $('.slider-banner').on('init', function(event, slick){
        setTimeout(function(){
            $('.slider-banner').addClass('slickinit');
        },300);
    });
    $('.slider-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:5000,
        speed:1500,
        fade:true,
        arrows: true,
        dots:true,
        prevArrow:'<div class="btn-slick-prev"></div>',
        nextArrow:'<div class="btn-slick-next"></div>',
        dotsClass: 'custom_paging',
        customPaging: function (slider, i) {
            return '<i>' + (i + 1) + '</i> / ' + slider.slideCount;
        }
    });
    var a_name = $('.va .mname').data('name');
    var a_arr = a_name.split(',');
    $('.slick-a').on('beforeChange' ,function(event, slick, currentSlide, nextSlide){
        $('.va .mname').text(a_arr[nextSlide]);
      });
    $('.slick-a').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        pauseOnHover:false,
        pauseOnFocus: false,
        draggable:false,
        autoplay:false,
        autoplay:true,
        autoplaySpeed:3000,
        speed:1500,
        dots:true,
        customPaging : function(slider, i) {
            return '<span></span>';
        },
    });
    $('.slick-c').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        pauseOnHover:false,
        pauseOnFocus: false,
        draggable:false,
        autoplay:false,
        autoplay:true,
        autoplaySpeed:3000,
        speed:1500,
        dots:true,
        customPaging : function(slider, i) {
            return '<span></span>';
        },
    });
    $('.vg .imgbox').simplyScroll({
        autoMode: 'loop',
        speed: 1,
        frameRate: 60,
        horizontal: true,
        pauseOnHover: false,
        pauseOnTouch: false
    });
    $('.vd .imgbox').simplyScroll({
        autoMode: 'loop',
        speed: 1,
        frameRate: 60,
        horizontal: true,
        pauseOnHover: false,
        pauseOnTouch: false
    });
    $("#twzipcode").twzipcode({
        onCountySelect: function() {
            if($(this).val() == ""){
                $('#city_span').html("必填");
                $("#twzipcode").addClass('nonsel');
			}else {
                $('#city_span').html("");
                $("#twzipcode").removeClass('nonsel');
            }
        }
    });
    
});

function revealOnScroll() {
    var scrolled = $window.scrollTop(),
        win_height_padded = $window.height() * 0.9;

   
    $(".revealOnScroll:not(.animated)").each(function () {
    var $this     = $(this),
        offsetTop = $this.offset().top;

    if (scrolled + win_height_padded > offsetTop) {
        $this.addClass('animated');
    }
    });
}
